import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 8px;
  margin-right: 6px;
  min-width: 22px;
  padding-left: 0px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
